export default "__VITE_ASSET__ClzGzwKD__"